module.exports = __webpack_public_path__ + "img/waves-8.bb5203e1.webp";